import { Link } from "react-router";
import { AVAILABILITY } from "@handvero/shared";

/** Schmaler Streifen ganz oben auf jeder Seite der Website. */
export function StartBanner() {
  return (
    <div className="start-banner" role="note">
      <div className="wrap">
        <span className="start-tag">Demo</span>
        <span>
          HandVero ist in der Startphase und noch nicht vollständig verfügbar. Nutzbar sind heute die Website, die Handy-Web-App und die
          Windows-Software.
        </span>
        <Link to="/stand">Was geht heute?</Link>
      </div>
    </div>
  );
}

/** Was heute nutzbar ist und was erst mit der Windows-Software kommt. */
export function StatusBoard() {
  return (
    <ul className="status-board">
      {AVAILABILITY.map((a) => (
        <li key={a.name} className={a.available ? "is-on" : "is-off"}>
          <div>
            <b>{a.name}</b>
            <small>{a.text}</small>
          </div>
          <span className={`tag${a.available ? " go" : ""}`}>{a.available ? "Jetzt nutzbar" : "Bald verfügbar"}</span>
        </li>
      ))}
    </ul>
  );
}

/** Hinweis zur Eigenverantwortung für die Datensicherung. */
export function BackupNotice() {
  return (
    <div className="notice info backup-notice" role="note">
      <b>Wichtig zur Datensicherung:</b> In der Startphase sind Sie selbst dafür verantwortlich, Ihre Daten zu sichern. Wir sagen derzeit keine
      automatische Datensicherung zu. Speichern Sie wichtige Fotos, Dokumente und Nachweise bitte zusätzlich bei sich. Details finden Sie in den{" "}
      <Link to="/rechtliches#agb">Nutzungsbedingungen</Link>.
    </div>
  );
}
